import { useState } from "react";
import { Button, Form, Input, Select, Space } from "antd";
import DeviceApi from "../../../../../../../api/DeviceApi";
import MapPicker from "../../../../../../../components/ui-components/map-picker/MapPicker";
import { FormRow, FormWrapper, MapPickerWrapper, OperationWrapper, Title, TitleWrapper, UpdateGatewayInformationWrapper } from "./UpdateGatewayInformation.styled";

interface UpdateGatewayInformationProps {
    gatewayView: any,
    onClose: ()=> void,
    onComplete: ()=> void,
}

export const UpdateGatewayInformation: React.FC<UpdateGatewayInformationProps> = (props)=> {
    // api
    let deviceApi = new DeviceApi();

    // form
    const [form] = Form.useForm();

    // state
    let gateway = props.gatewayView.gateway;
    let [gatewayInformation, setGatewayInformation] = useState({
        id: gateway.id,
        name: gateway.name,
        positioningMethod: gateway.positioningMethod,
        geoLatitude: gateway.geoLatitude,
        geoLongitude: gateway.geoLongitude,
        deviceNo: gateway.deviceNo,
        remarks: gateway.remarks,
    });
    let [submitEnabled, setSubmitEnabled] = useState(false);

    // validate
    let validateForm = ()=> {
        form.validateFields().then((values)=> {
            setSubmitEnabled(true);
        }).catch((err)=> {
            setSubmitEnabled(false);
            console.log(err);
        });
    };

    // events
    let onGatewayNameChange = (e)=> {
        gatewayInformation.name = e.target.value;
        setGatewayInformation({...gatewayInformation});
        validateForm();
    };

    let onGatewayNoChange = (e)=> {
        gatewayInformation.deviceNo = e.target.value;
        setGatewayInformation({...gatewayInformation});
        validateForm();
    };

    let onPositionMethodChange = (value)=> {
        gatewayInformation.positioningMethod = value;
        setGatewayInformation({...gatewayInformation});
        validateForm();
        setTimeout(()=> {
            validateForm();
        });
    };

    let onPick = (lng, lat)=> {
        gatewayInformation.geoLatitude = lat;
        gatewayInformation.geoLongitude = lng;
        setGatewayInformation({...gatewayInformation});
        form.setFieldsValue(gatewayInformation);
        validateForm();
    };

    let onRemarksChange = (e)=> {
        gatewayInformation.remarks = e.target.value;
        setGatewayInformation({...gatewayInformation});
        validateForm();
    };

    let onSubmit = async ()=> {
        await deviceApi.update({
            ...gatewayInformation,
        });
        props.onComplete();
        props.onClose();
    };

    let onCancel = ()=> {
        props.onClose();
    };

    // render
    
    let positionMethodOptions = [
        {
            label: '自动定位',
            value: 'AUTO',
        }, {
            label: '手动定位',
            value: 'MANUAL',
        },
    ];

    return (
        <UpdateGatewayInformationWrapper>
            <TitleWrapper>
                <Title>编辑网关</Title>
            </TitleWrapper>

            <FormWrapper>
                <Form form={form} name="form" layout="vertical">
                    <Form.Item name="name" label="网关名称" rules={[{required: true}]} initialValue={gatewayInformation.name}>
                        <Input onChange={onGatewayNameChange} />
                    </Form.Item>

                    <Form.Item name="deviceNo" label="网关编号" rules={[{required: true}]} initialValue={gatewayInformation.deviceNo}>
                        <Input onChange={onGatewayNoChange} />
                    </Form.Item>

                    <Form.Item name="nodeSn" label="网关序列号" rules={[{required: true}]} initialValue={props.gatewayView.node.sn}>
                        <Input disabled={true}/>
                    </Form.Item>

                    <FormRow>
                        <Form.Item name="positioningMethod" label="定位方式" rules={[{required: true}]} initialValue={gatewayInformation.positioningMethod} style={{flex: '2 2 0px'}}>
                            <Select
                                placeholder="请选择定位方式"
                                onChange={onPositionMethodChange}
                                options={positionMethodOptions}
                            />
                        </Form.Item>

                        {gatewayInformation.positioningMethod === 'MANUAL' &&
                            <Form.Item name="geoLongitude" label="经度" rules={[{required: true}]} initialValue={gatewayInformation.geoLongitude}>
                                <Input disabled={true} value={gatewayInformation.geoLongitude}/>
                            </Form.Item>
                        }
                        {gatewayInformation.positioningMethod === 'MANUAL' &&
                            <Form.Item name="geoLatitude" label="纬度" rules={[{required: true}]} initialValue={gatewayInformation.geoLatitude}>
                                <Input disabled={true} value={gatewayInformation.geoLatitude}/>
                            </Form.Item>
                        }
                    </FormRow>

                    {gatewayInformation.positioningMethod === 'MANUAL' && <FormRow>
                        <MapPickerWrapper>
                            <MapPicker lng={gatewayInformation.geoLongitude} lat={gatewayInformation.geoLatitude} onPick={onPick} />
                        </MapPickerWrapper>
                    </FormRow>
                    }
                    <Form.Item name="remarks" label="备注" rules={[{required: false}]} initialValue={gatewayInformation.remarks}>
                        <Input.TextArea style={{height: '100px'}} onChange={onRemarksChange}/>
                    </Form.Item>
                </Form>
            </FormWrapper>

            <OperationWrapper>
                <Space size="middle">
                    <Button type="primary" disabled={!submitEnabled} onClick={onSubmit}>确定</Button>
                    <Button type="primary" danger onClick={onCancel}>取消</Button>
                </Space>
            </OperationWrapper>
        </UpdateGatewayInformationWrapper>
    );
};

export default UpdateGatewayInformation;
